import { defineCustomElement } from '@tyler-components-web/core';
import { AppLauncherComponent } from './app-launcher';
export * from './app-launcher-adapter';
export * from './app-launcher-constants';
export * from './app-launcher-foundation';
export * from './app-launcher';
export function defineAppLauncherComponent() {
    defineCustomElement(AppLauncherComponent);
}
